import { Link, useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

const WhatsAppFab = () => {
  const { settings } = useSettings();
  const { pathname } = useLocation();
  if (settings.sections?.whatsapp_fab === false) return null;

  const onClick = (e) => {
    if (pathname !== "/contact") return;
    e.preventDefault();
    document.getElementById("formulaire")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <Link
      to="/contact?type=devis#formulaire"
      onClick={onClick}
      data-testid="whatsapp-floating-button"
      aria-label="WhatsApp"
      className="animate-pulse-ring fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-brand text-white transition-transform duration-300 hover:scale-110"
    >
      <MessageCircle className="h-6 w-6" />
    </Link>
  );
};

export default WhatsAppFab;
